import { getCSRCookieData } from '@/app/api/CSR/getCSRCookieData'
import { setCookieCSR } from '@/app/api/CSR/setCookieCSR'
import { storage } from '@mercadoni/sinister/dist/cjs/shared/utils'
import { CartOperationlModels, DeadpoolUser } from '~types/index'
import { CART_FALLBACK, CART_ID, CART_MIGRABLE } from '../constants'
import getStoredCartId from './getStoredCartId'

interface baseParams {
  clientId: string
  storeReference: string
  addressId: string | undefined
  operationalModel: CartOperationlModels | undefined
}

interface CartInitalizerProps extends baseParams {
  storedCartId: string | null
  customer: string | undefined
  isLogged: boolean
  callback: (type: string) => void
}

export interface InitializeCartProps {
  baseParams: baseParams
  customer: DeadpoolUser | null
  restart: (params: baseParams) => void
  cartId: string
  initializer: (params: CartInitalizerProps) => void
}

const initializeCart = async ({
  baseParams,
  customer,
  restart,
  cartId,
  initializer,
}: InitializeCartProps) => {
  const db = storage('local')
  const cartCallback = (type: string) => {
    console.log('🚀 CartContext/InitializeCart  - cartCallback', type)
    db.removeItem(CART_MIGRABLE)
  }

  const localSCartId: string | null = db.getItem(CART_ID) || null
  const fallbackCartId: string | null = getCSRCookieData(CART_FALLBACK) || null
  const storedCartId: string | null = getStoredCartId({ customer })

  if (!fallbackCartId && !localSCartId && !customer) {
    console.log('🚀 CartContext/InitializeCart  - initializeCart', {
      baseParams,
    })
    await restart(baseParams)
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    return () => {}
  }

  if (localSCartId && localSCartId !== fallbackCartId) {
    setCookieCSR(CART_FALLBACK, cartId, 0.001) // 1 minute
  }

  const initializerParams: CartInitalizerProps = {
    ...baseParams,
    storedCartId,
    customer: customer?.id,
    isLogged: !!customer,
    callback: cartCallback,
  }

  await initializer(initializerParams)
}

export default initializeCart
